export var palette = {
    hero: {
        200: '#BDD3DF',
        300: '#32627A',
        400: '#264B5D'
    },
    primary: {
        300: '#046FFF'
    },
    shade: {
        white: {
            default: '#FFFFFF',
            transparent: 'rgba(255, 255, 255, 0)'
        },
        dark: {
            default: '#33373E'
        }
    },
    brand: {
        motivators: {
            gaps: {
                first: '#a430e2',
                second: '#75b240'
            },
            color: {
                innovation: '#d482bd',
                altruism: '#59be71',
                autonomy: '#54c4c3',
                security: '#f7b844',
                progress: '#ef6d45',
                status: '#c0c0c0',
                financial_needs: '#d2a952',
                competition: '#DA5957',
                feedback: '#7FB15B',
                rationality: '#408BC9',
                social_relationships: '#EC619F'
            },
            background: {
                innovation: '#9F4486',
                altruism: '#2C653B',
                autonomy: '#3B8E8D',
                security: '#946F1A',
                progress: '#9D5846',
                status: '#888888',
                financial_needs: '#946F1A',
                competition: '#903636',
                feedback: '#547E36',
                rationality: '#285D87',
                social_relationships: '#9C3863'
            }
        }
    }
};

//# sourceMappingURL=palette.js.map